import TabPanel from './TabPanel';
import TabsContext from './TabsContext';
import Tabs from './Tabs';

export { TabPanel, TabsContext };
export default Tabs;
